import React from 'react';
import {
  Box,
  Button,
  Grid,
  Modal,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';


export default function ConfirmDeletePerk({
  visible,
  onClose,
  onConfirm,
}) {
  const theme = useTheme();

  return (
    <Modal
      open={visible}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Grid sx={{ width: '80%', margin: 'auto' }} className="text-center">
          <Grid container justifyContent='center' alignItems='center' className="swal-question swal-close" sx={{ borderColor: "#009ef7" }}>
            <Grid className="swal-x-content" sx={{ fontSize: '2.75em', color: '#009ef7' }}>?</Grid>
          </Grid>
          <Typography id="modal-modal-description" sx={{ mt: 2, textAlign: 'center', fontSize: '17px', fontWeight: '500', color: theme.palette.mode === 'light' ? '#181c32' : '#fff' }}>
            You are about to delete this park.
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2, textAlign: 'center', fontSize: '14px', color: theme.palette.mode === 'light' ? '#3f4254' : '#cdcdde' }}>
            All data associated with this perk will also be{'\n'}removed. Do you wish to proceed?
          </Typography>
          <Grid item container direction='row' justifyContent='center' alignItems='center' display="flex" sx={{ mt: 3 }}>
            <Button
              color="success"
              variant="contained"
              sx={{ color: '#fff', fontSize: '14px', fontWeight: '500', textTransform: 'none', padding: '11px 20px' }}
              onClick={onConfirm}
            >
              Confirm
            </Button>
            <Button
              color="error"
              variant="contained"
              sx={{ marginInlineStart: 2, fontSize: '14px', fontWeight: '500', textTransform: 'none', color: '#fff', padding: '11px 20px' }}
              onClick={onClose}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
